import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountTemplateLibrary implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxTemplateLibraryContainer";
    }
    render(){
        let self=this;
        this.zidx.loadFunctions.push(function () {
            $(".zidxPageActive #zidxTemplateLibraryAdd", self.zidx.peakidxShadowRoot).off("click.k04").on("click.k04", function (e: JQuery.ClickEvent) {
                e.preventDefault();
                let select=$(".zidxPageActive #zidxTemplateLibraryNewKind", self.zidx.peakidxShadowRoot).get(0) as HTMLSelectElement|undefined;
                if(!select || select.value==""){
                    return;
                }
                self.zidx.loadPushStateURL("/account/template-library/edit?kind="+encodeURIComponent(select.value), false);
            });
        });
    }
}
